var chunkMapping = {
	"webpack_container_remote_reactRichComponents_communication_TemplateForm": [
		"webpack/container/remote/reactRichComponents/communication/TemplateForm"
	],
	"webpack_container_remote_reactRichComponents_visitors_ApprovalChainDetailsCard": [
		"webpack/container/remote/reactRichComponents/visitors/ApprovalChainDetailsCard"
	],
	"webpack_container_remote_reactRichComponents_communication_SendMessage": [
		"webpack/container/remote/reactRichComponents/communication/SendMessage"
	],
	"webpack_container_remote_reactRichComponents_communication_ControlCenter": [
		"webpack/container/remote/reactRichComponents/communication/ControlCenter"
	],
	"webpack_container_remote_reactRichComponents_communication_ThreatIntelligenceSettings": [
		"webpack/container/remote/reactRichComponents/communication/ThreatIntelligenceSettings"
	],
	"webpack_container_remote_reactRichComponents_styles": [
		"webpack/container/remote/reactRichComponents/styles"
	],
	"webpack_container_remote_reactRichComponents_config": [
		"webpack/container/remote/reactRichComponents/config"
	],
	"webpack_container_remote_reactRichComponents_shadow-dom": [
		"webpack/container/remote/reactRichComponents/shadow-dom"
	],
	"webpack_container_remote_reactRichComponents_shadow-dom-styles": [
		"webpack/container/remote/reactRichComponents/shadow-dom-styles"
	],
	"webpack_container_remote_reactRichComponents_communication_ThreatDashboard": [
		"webpack/container/remote/reactRichComponents/communication/ThreatDashboard"
	],
	"webpack_container_remote_reactRichComponents_communication_WeatherAlerts": [
		"webpack/container/remote/reactRichComponents/communication/WeatherAlerts"
	],
	"webpack_container_remote_reactRichComponents_visitors_GlobalVisitorApprovals": [
		"webpack/container/remote/reactRichComponents/visitors/GlobalVisitorApprovals"
	],
	"webpack_container_remote_reactRichComponents_visitors_UpdateDraftPolicy": [
		"webpack/container/remote/reactRichComponents/visitors/UpdateDraftPolicy"
	],
	"webpack_container_remote_reactRichComponents_visitors_Policies": [
		"webpack/container/remote/reactRichComponents/visitors/Policies"
	],
	"webpack_container_remote_reactRichComponents_visitors_PolicyDetails": [
		"webpack/container/remote/reactRichComponents/visitors/PolicyDetails"
	],
	"webpack_container_remote_reactRichComponents_producer-map_ProducerMapView": [
		"webpack/container/remote/reactRichComponents/producer-map/ProducerMapView"
	],
	"webpack_container_remote_reactRichComponents_visitors_devices_printers_PrinterOverviewView": [
		"webpack/container/remote/reactRichComponents/visitors/devices/printers/PrinterOverviewView"
	],
	"webpack_container_remote_reactRichComponents_visitors_WorkflowDebugPage": [
		"webpack/container/remote/reactRichComponents/visitors/WorkflowDebugPage"
	],
	"webpack_container_remote_reactRichComponents_visitors_profiles_VisitorProfileView": [
		"webpack/container/remote/reactRichComponents/visitors/profiles/VisitorProfileView"
	],
	"webpack_container_remote_reactRichComponents_workplace_Approvals": [
		"webpack/container/remote/reactRichComponents/workplace/Approvals"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/reactRichComponents/communication/TemplateForm": [
		"default",
		"./communication/TemplateForm",
		"webpack/container/reference/reactRichComponents"
	],
	"webpack/container/remote/reactRichComponents/visitors/ApprovalChainDetailsCard": [
		"default",
		"./visitors/ApprovalChainDetailsCard",
		"webpack/container/reference/reactRichComponents"
	],
	"webpack/container/remote/reactRichComponents/communication/SendMessage": [
		"default",
		"./communication/SendMessage",
		"webpack/container/reference/reactRichComponents"
	],
	"webpack/container/remote/reactRichComponents/communication/ControlCenter": [
		"default",
		"./communication/ControlCenter",
		"webpack/container/reference/reactRichComponents"
	],
	"webpack/container/remote/reactRichComponents/communication/ThreatIntelligenceSettings": [
		"default",
		"./communication/ThreatIntelligenceSettings",
		"webpack/container/reference/reactRichComponents"
	],
	"webpack/container/remote/reactRichComponents/styles": [
		"default",
		"./styles",
		"webpack/container/reference/reactRichComponents"
	],
	"webpack/container/remote/reactRichComponents/config": [
		"default",
		"./config",
		"webpack/container/reference/reactRichComponents"
	],
	"webpack/container/remote/reactRichComponents/shadow-dom": [
		"default",
		"./shadow-dom",
		"webpack/container/reference/reactRichComponents"
	],
	"webpack/container/remote/reactRichComponents/shadow-dom-styles": [
		"default",
		"./shadow-dom-styles",
		"webpack/container/reference/reactRichComponents"
	],
	"webpack/container/remote/reactRichComponents/communication/ThreatDashboard": [
		"default",
		"./communication/ThreatDashboard",
		"webpack/container/reference/reactRichComponents"
	],
	"webpack/container/remote/reactRichComponents/communication/WeatherAlerts": [
		"default",
		"./communication/WeatherAlerts",
		"webpack/container/reference/reactRichComponents"
	],
	"webpack/container/remote/reactRichComponents/visitors/GlobalVisitorApprovals": [
		"default",
		"./visitors/GlobalVisitorApprovals",
		"webpack/container/reference/reactRichComponents"
	],
	"webpack/container/remote/reactRichComponents/visitors/UpdateDraftPolicy": [
		"default",
		"./visitors/UpdateDraftPolicy",
		"webpack/container/reference/reactRichComponents"
	],
	"webpack/container/remote/reactRichComponents/visitors/Policies": [
		"default",
		"./visitors/Policies",
		"webpack/container/reference/reactRichComponents"
	],
	"webpack/container/remote/reactRichComponents/visitors/PolicyDetails": [
		"default",
		"./visitors/PolicyDetails",
		"webpack/container/reference/reactRichComponents"
	],
	"webpack/container/remote/reactRichComponents/producer-map/ProducerMapView": [
		"default",
		"./producer-map/ProducerMapView",
		"webpack/container/reference/reactRichComponents"
	],
	"webpack/container/remote/reactRichComponents/visitors/devices/printers/PrinterOverviewView": [
		"default",
		"./visitors/devices/printers/PrinterOverviewView",
		"webpack/container/reference/reactRichComponents"
	],
	"webpack/container/remote/reactRichComponents/visitors/WorkflowDebugPage": [
		"default",
		"./visitors/WorkflowDebugPage",
		"webpack/container/reference/reactRichComponents"
	],
	"webpack/container/remote/reactRichComponents/visitors/profiles/VisitorProfileView": [
		"default",
		"./visitors/profiles/VisitorProfileView",
		"webpack/container/reference/reactRichComponents"
	],
	"webpack/container/remote/reactRichComponents/workplace/Approvals": [
		"default",
		"./workplace/Approvals",
		"webpack/container/reference/reactRichComponents"
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}